module.exports = __webpack_public_path__ + "static/img/wachat.1597b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/wachat.png
// module id = WGyL
// module chunks = 1